import { useState } from 'react';

/**
 * Which of `columns` (`[{ key, label, hideable? }]`; the first always shows, so does any with `hideable: false`) are
 * hidden, remembered in this browser under `storageKey` (none: for this visit only). `{ shown, show, toggle }`.
 */
export function useHiddenColumns(storageKey, columns) {
  const hideable = columns.slice(1).filter((column) => column.hideable !== false).map((column) => column.key);
  const [hidden, setHidden] = useState(() => {
    if (!storageKey) { return []; }
    try {
      const saved = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(saved) ? saved.filter((key) => hideable.includes(key)) : [];
    } catch (_error) { return []; }
  });
  const toggle = (key) => setHidden((now) => {
    const next = now.includes(key) ? now.filter((x) => x !== key) : [...now, key];
    if (storageKey) {
      try { window.localStorage.setItem(storageKey, JSON.stringify(next)); } catch (_error) { /* kept for this visit only */ }
    }
    return next;
  });
  const show = (key) => !hidden.includes(key) || !hideable.includes(key);
  return { shown: columns.filter((column) => show(column.key)), show, toggle };
}

export default useHiddenColumns;
